import { FacilityBillingRate } from 'src/app/facility-contracts/facilities/models/facility-billing-rate.model';

export class FacilityBillingRateModel {
    constructor(rate: FacilityBillingRate) {
        this.facilityBillingRate = rate;
    }

    facilityBillingRate: FacilityBillingRate;
    splitedHours: boolean;
}
